module.exports = {"450124100":"白山镇","450124101":"百龙滩镇","450124102":"林圩镇","450124103":"古零镇","450124104":"金钗镇","450124105":"周鹿镇","450124106":"永州镇","450124200":"乔利乡","450124201":"加方乡","450124202":"古寨瑶族乡","450124203":"里当瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450124.json
// module id = 2203
// module chunks = 0